import anime from 'animejs';
import Image from 'gatsby-image';
import _get from 'lodash.get';
import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import Lottie from 'react-lottie';
import TrackVisibility from 'react-on-screen';
import { MixBlendDifference, responsiveFontSize } from 'style';
import eventsService from '../../utils/events.service';
import VideoMediaComponent from './media.video.component';
import ExternalVideoMediaComponent from '../media/media.externalvideo.component';

class MediaComponent extends React.Component {
    render() {
        const {
            image,
            video,
            loop,
            backgroundColor,
            textOverlay,
            showFullscreenControl = false,
            showMuteControl = false,
            onLoad = () => {
                return;
            },
            autoplay = false,
            aspectRatio,
            alt = '',
            title = '',
        } = this.props;
        let visible = this.props.visible;
        if (visible == null) {
            visible = false;
        }
        if (video && autoplay == false) video.autoplay = false;
        if (image && autoplay == false) image.autoplay = false;

        return renderMedia(
            image,
            video,
            loop,
            backgroundColor,
            visible,
            showFullscreenControl,
            showMuteControl,
            onLoad,
            aspectRatio,
            textOverlay,
            alt,
            title
        );
    }
}

const getSVG = image => {
    //console.log(image);
    return _get(image, 'inlineSvg', '');
};

const renderMedia = (
    image,
    video,
    loop,
    backgroundColor,
    visible,
    showFullscreenControl,
    showMuteControl,
    onLoad,
    aspectRatio,
    textOverlay,
    alt,
    title
) => {
    if (video) {
        return (
            <TrackVisibility
                partialVisibility
                css={visibility_css}
                className="media media-video">
                <ExternalVideoMediaComponent
                    video={video}
                    loop={loop}
                    visible={visible}
                    textOverlay={textOverlay}
                    showFullscreenControl={showFullscreenControl}
                    showMuteControl={showMuteControl}
                    backgroundColor={backgroundColor}
                    onLoad={onLoad}
                    aspectRatio={video.height / video.width}
                />
            </TrackVisibility>
        );
    }
    if (image) {
        if (image.format === 'svg') {
            //   console.log('svg', image);
            onLoad();
            return image.url ? (
                <img
                    src={image.url}
                    id="Media-SVG"
                    className="media media-svg"
                    alt={alt || image.alt}
                    title={title || image.title}
                />
            ) : (
                <InlineSVG
                    id="Media-SVG"
                    dangerouslySetInnerHTML={{
                        __html: getSVG(image),
                    }}
                />
            );
        }
        if (image.format === 'json') {
            //   console.log('lottie', image);
            onLoad();
            return (
                <TrackVisibility
                    partialVisibility
                    className="media media-lottie">
                    <LottieMediaComponent
                        image={image}
                        loop={loop}
                        visible={visible}
                        alt={alt || image.alt}
                        title={title || image.title}
                    />
                </TrackVisibility>
            );
        }
        if (image.format === 'mp4' || image.format === 'm4v') {
            return (
                <TrackVisibility
                    partialVisibility
                    css={visibility_css}
                    className="media media-video">
                    {/* <VideoMediaComponent
                        video={image}
                        loop={loop}
                        visible={visible}
                        textOverlay={textOverlay}
                        showFullscreenControl={showFullscreenControl}
                        showMuteControl={showMuteControl}
                        backgroundColor={backgroundColor}
                        onLoad={onLoad}
                        aspectRatio={aspectRatio}
                    /> */}
                    <ExternalVideoMediaComponent
                        video={image}
                        loop={loop}
                        visible={visible}
                        textOverlay={textOverlay}
                        showFullscreenControl={showFullscreenControl}
                        showMuteControl={showMuteControl}
                        backgroundColor={backgroundColor}
                        onLoad={onLoad}
                        aspectRatio={aspectRatio}
                    />
                </TrackVisibility>
            );
        }
        if (image.format === 'gif') {
            image.sizes.src = image.url;
            // delete image.sizes.srcSet;
            image.sizes.srcSet = '';
            return (
                <Image
                    {...image}
                    id="Media-Image"
                    fadeIn={false}
                    backgroundColor={backgroundColor}
                    css={image_css}
                    className="media media-image"
                    nopin="nopin"
                    onLoad={onLoad}
                    alt={alt || image.alt}
                    title={title || image.title}
                />
            );
        }
        return (
            <Image
                {...image}
                id="Media-Image"
                fadeIn={false}
                backgroundColor={backgroundColor}
                css={image_css}
                className="media media-image"
                nopin="nopin"
                onLoad={onLoad}
                alt={alt || image.alt}
                title={title || image.title}
                imgStyle={image.focalPoint ? {objectPosition: `${image.focalPoint.x*100}% ${image.focalPoint.y*100}%`} : false}
            />
        );
    }
    return <div />;
};

class LottieMediaComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            paused: !props.visible,
            loop: props.loop,
            jsonData: props.image && props.image.jsonData ? JSON.parse(props.image.jsonData) : {layers: []},
        };

        this.animationComplete = false;

        this.onVisibleChange = this.onVisibleChange.bind(this);
    }
    componentWillReceiveProps(props) {
        this.onVisibleChange(props.isVisible);
    }
    onVisibleChange(visible) {
        this.setState({ paused: !visible });
    }
    render() {
        // console.log('Lottie', this.state.jsonData);
        return (
            <LottieContainer>
                <Lottie
                    id="Media-Lottie"
                    options={{
                        loop: this.state.loop,
                        autoplay: false,
                        animationData: this.state.jsonData,
                        rendererSettings: {
                            preserveAspectRatio: 'xMidYMid',
                        },
                    }}
                    alt={this.props.alt}
                    title={this.props.title}
                    width={'auto'}
                    height={'auto'}
                    isStopped={false}
                    isPaused={this.state.paused}
                />
            </LottieContainer>
        );
    }
}

const visibility_css = css`
    height: 100%;
    position: relative;
`;

const LottieContainer = styled.div`
    text-align: center;
    svg {
        width: auto !important;
        height: auto !important;
        max-width: 100%;
    }
`;

const image_css = css`
    width: 100%;
    .gatsby-image-outer-wrapper {
        width: 100%;
    }
`;

const InlineSVG = styled.div`
    max-width: 100%;
    width: 100%;
    height: 100%;
    svg {
        overflow: initial;
        max-width: 100%;
        height: auto;
        width: auto;
    }
`;

export default MediaComponent;
